// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

type SectionTitleProps = Readonly<{
  children: React.ReactNode;
  className?: string;
}>;

export function SectionTitle({ children, className = '' }: SectionTitleProps) {
  return (
    <div className={`text-black text-h5 font-medium leading-normal font-sans !m-0 ${className}`}>
      {children}
    </div>
  );
}
